import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Menu, MenuItem } from "@material-ui/core";
import { taskUnassign, taskEnroute, taskOnsite, taskComplete } from "../../redux/task/taskActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { STATUSES } from "../../globals/workOrderStatus";
import { WorkOrderActionIcon } from "../common/icons/workOrderStatusIconHelper";
import InCompleteJob from "../admin/incompleteJob";
import CompletionCode from "../admin/completionCodePopup";
import { useLocalizedName } from "../../globals/langHelpers";

import "./styles.css";
import { ALERT_TYPES } from "../../redux/alert/alertActions";
import { FormattedMessage } from "react-intl";

const initialState = {
    mouseX: null,
    mouseY: null,
};

const useStyles = makeStyles((theme) => ({
    menu: {
        "& div": {
            padding: "0px",
            "& li": {
                paddingLeft: "16px",
            },
            "& .MuiList-padding": {
                paddingTop: "0px",
            },
        },
        "& .actions-gantt-view": {
            minWidth: "300px",
            padding: "0px",
            "& div": {
                padding: "0px",
            },
            "& .actions-header": {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 15px",
                backgroundColor: "var(--blue-bell)",
                margin: "0 0 10px 0",
                "& .actions-header-right": {
                    color: "var(--text-white)",
                    margin: "2px",
                    padding: "5px",
                    fontWeight: "bold",
                    fontSize: "22px",
                    lineHeight: "40px",
                    cursor: "pointer",
                    "> :hover": {
                        border: "1.5px solid #00549A",
                    },
                },
                "& .actions-header-left": {
                    "& .you-are-currently": {
                        fontWeight: "normal",
                        fontSize: "12px",
                        lineHeight: "14px",
                        color: "var(--text-white)",
                    },
                    "& .current-status": {
                        fontWeight: "bold",
                        fontSize: "18px",
                        lineHeight: "22px",
                        color: "var(--text-white)",
                    },
                },
            },
        },
    },
    icon: {
        color: "var(--blue-bell)",
        marginRight: "20px",
    },
    statusText: {
        color: "var(--blue-bell)",
    },
    statusHeader: {
        color: "var(--text-medium)",
        fontFamily: "Arial",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "13.8px",
        letterSpacing: "-0.15px",
        textAlign: "left",
        paddingLeft: "0px",
        margin: "15px 0px",
        display: "block",
    },
}));

// This function allows to right click on workOrderNumber to change task status
function AdminContextMenu(props) {
    const task = props.task;
    const history = useHistory();
    const classes = useStyles();
    const [state, setState] = React.useState(initialState);
    const [completing, setCompleting] = React.useState(false);
    const [completion, setCompletion] = React.useState(false);
    const [inCompleting, setIncompleting] = React.useState(false);
    const { getLocalizedName } = useLocalizedName();

    const filteredTaskData = props.tasks.filter((item) => item?.workOrderNumber === task?.workOrderNumber)[0];
    useEffect(() => {
        if (completing && task && task.status && task.status.id === STATUSES.PENDING_REVIEW) {
            setCompleting(false);
            history.push(`/workorderdetails/${task.workOrderNumber}`);
        }
    }, [task]);

    useEffect(() => {
        // If an error alert shows up, user tried to complete, but the status did not change, there was an error, so reset Completing
        if (completing && props.alerts.length > 0 && props.alerts[0].type === ALERT_TYPES.error && task.status.id !== STATUSES.PENDING_REVIEW) {
            setCompleting(false);
        }
    }, [props.alerts]);

    const handleClick = (event) => {
        event.preventDefault();
        setState({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
        });
    };

    const handleClose = () => {
        setState(initialState);
    };

    const unAssignTask = () => {
        props.triggerUnassign(task.workOrderNumber);
        handleClose();
    };

    const enrouteTask = () => {
        props.triggerEnroute(task.workOrderNumber, false);
        handleClose();
    };

    const onsiteTask = () => {
        props.triggerOnsite(task.workOrderNumber, false);
        handleClose();
    };

    const completeTask = (val, completionDate) => {
        const payload = {
            workOrderNumber: task?.workOrderNumber,
            userName: props?.userInfo?.preferred_username,
            completionCode: +val,
            completionDate: completionDate,
        };
        setCompleting(true);
        completionCloseModal(true, true);
        props.triggerComplete(payload);
        // if(showDetails)
        //     history.push(`/workorderdetails/${task.workOrderNumber}`)
        // handleClose();
        // setCompletion(close);
    };

    const completeTasks = () => {
        setCompletion(true);
    };

    const inCompleteTask = () => {
        setIncompleting(true);
    };

    const closeModal = (close, showDetails) => {
        setIncompleting(close);
        if (showDetails) history.push(`/workorderdetails/${task.workOrderNumber}`);
    };
    const completionCloseModal = (close, showDetails) => {
        setCompletion(close);
        if (showDetails) history.push(`/workorderdetails/${task.workOrderNumber}`);
    };

    if (!props.task) {
        return null;
    }
    return (
        <>
            <div onContextMenu={handleClick}>
                {props.from === "gantt-view" ? (
                    <>
                        <div className={"cmis-gantt-wo-caption " + props.overlap}> WO # </div>
                        <div className={"cmis-gantt-wo-number " + props.overlap}> {task.workOrderNumber} </div>
                    </>
                ) : (
                    <Link
                        to={{
                            pathname: `/workorderdetails/${task.workOrderNumber}`,
                        }}
                        style={{ color: "#00549A" }}>
                        <span
                        // onMouseDown={() => { props.setSelectedTask(task); }}
                        >
                            {" "}
                            {task.workOrderNumber}{" "}
                        </span>
                    </Link>
                )}
            </div>
            {((task.status && props.from === "gantt-view") ||
                (task.status && [STATUSES.ASSIGNED, STATUSES.ENROUTE, STATUSES.ONSITE, STATUSES.INCOMPLETE].includes(task.status.id))) && (
                <Menu
                    className={classes.menu}
                    keepMounted
                    open={state.mouseY !== null}
                    onClose={handleClose}
                    anchorReference="anchorPosition"
                    anchorPosition={state.mouseY !== null && state.mouseX !== null ? { top: state.mouseY, left: state.mouseX } : undefined}>
                    {props.from === "gantt-view" && (
                        <div className="actions-gantt-view">
                            <div className="actions-header">
                                <div className="actions-header-left">
                                    <div className="you-are-currently">
                                        <FormattedMessage
                                            id="work-order-actions.your-currently"
                                            defaultMessage="You are currently:"
                                            description="Work order actions change status header"
                                        />
                                    </div>
                                    <div className="current-status"> {getLocalizedName({ object: task.status })}</div>
                                </div>
                                <div className="actions-header-right" onClick={handleClose}>
                                    X
                                </div>
                            </div>

                            <Link
                                to={{
                                    pathname: `/workorderdetails/${task.workOrderNumber}`,
                                }}
                                style={{ color: "#00549A", fontSize: "14px", lineHeight: "16px", padding: 15 }}>
                                <FormattedMessage
                                    id="work-order-actions.view-work-order-details"
                                    defaultMessage="View work order details"
                                    description="Link label for View work order details"
                                />
                            </Link>
                        </div>
                    )}

                    {[STATUSES.ASSIGNED, STATUSES.ENROUTE, STATUSES.ONSITE, STATUSES.INCOMPLETE].includes(task.status.id) && (
                        <div style={{ padding: "0px 15px 15px" }}>
                            <Typography className={classes.statusHeader}>
                                <FormattedMessage
                                    id="work-order-actions.change-status-header"
                                    defaultMessage="CHANGE STATUS TO:"
                                    description="Work order actions change status header"
                                />
                            </Typography>
                            {task.status && task.status.id === STATUSES.ASSIGNED && (
                                <MenuItem className={classes.statusText} onClick={unAssignTask}>
                                    <WorkOrderActionIcon className={classes.icon} id={STATUSES.UNASSIGNED} />
                                    <FormattedMessage
                                        id="work-order-actions.unassigned"
                                        defaultMessage="Unassigned"
                                        description="Work order unassigned action"
                                    />
                                </MenuItem>
                            )}
                            {task.status && task.status.id === STATUSES.ASSIGNED && (
                                <MenuItem className={classes.statusText} onClick={enrouteTask}>
                                    <WorkOrderActionIcon className={classes.icon} id={STATUSES.ENROUTE} />
                                    <FormattedMessage
                                        id="work-order-actions.enroute"
                                        defaultMessage="En route"
                                        description="Work order enroute action"
                                    />
                                </MenuItem>
                            )}
                            {task.status && task.status.id === STATUSES.ENROUTE && (
                                <MenuItem className={classes.statusText} onClick={onsiteTask}>
                                    <WorkOrderActionIcon className={classes.icon} id={STATUSES.ONSITE} />
                                    <FormattedMessage
                                        id="work-order-actions.onsite"
                                        defaultMessage="On site"
                                        description="Work order on site action"
                                    />
                                </MenuItem>
                            )}
                            {task.status && task.status.id === STATUSES.ONSITE && (
                                <MenuItem
                                    className={classes.statusText}
                                    onClick={filteredTaskData?.hasCompletionReasons ? completeTasks : completeTask}>
                                    <WorkOrderActionIcon className={classes.icon} id={STATUSES.COMPLETE} />
                                    <FormattedMessage
                                        id="work-order-actions.compete"
                                        defaultMessage="Complete"
                                        description="Work order compete action"
                                    />
                                </MenuItem>
                            )}
                            {task.status && task.status.id === STATUSES.ONSITE && (
                                <MenuItem className={classes.statusText} onClick={inCompleteTask}>
                                    <WorkOrderActionIcon className={classes.icon} id={STATUSES.CLOSED_INCOMPLETE} />
                                    <FormattedMessage
                                        id="work-order-actions.incomplete"
                                        defaultMessage="Incomplete job"
                                        description="Work order Incomplete Job action"
                                    />
                                </MenuItem>
                            )}

                            {task.status && task.status.id === STATUSES.INCOMPLETE && (
                                <MenuItem className={classes.statusText} onClick={unAssignTask}>
                                    <WorkOrderActionIcon className={classes.icon} id={STATUSES.UNASSIGNED} />
                                    <FormattedMessage
                                        id="work-order-actions.unassigned"
                                        defaultMessage="Unassigned"
                                        description="Work order unassigned action"
                                    />
                                </MenuItem>
                            )}
                        </div>
                    )}
                </Menu>
            )}
            {inCompleting && (
                <InCompleteJob
                    dueDate={task.dueDate}
                    workOrderNumber={task.workOrderNumber}
                    showInCompleteModal
                    setShowInCompleteModal={closeModal}
                />
            )}
            {completion && (
                <CompletionCode
                    dueDate={task.dueDate}
                    workOrderNumber={task.workOrderNumber}
                    showCompletionModal
                    setShowCompletionModal={completionCloseModal}
                    onCompletionCallback={completeTask}
                    workorderData={filteredTaskData}
                    cmisAdmin
                />
            )}
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        alerts: state.alerts,
        tasks: state.tasks.tasks,
        userInfo: state.login.userInfo,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
        ...bindActionCreators(
            {
                triggerUnassign: taskUnassign,
                triggerEnroute: taskEnroute,
                triggerOnsite: taskOnsite,
                triggerComplete: taskComplete,
            },
            dispatch,
        ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminContextMenu);
